import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { ASSIGNMENTS_QUERIES } from "~/shared/api/assignments/assignments.queries";
import { notFound } from "~/shared/util/notFound";

export function assignmentPreviewViewLoader({ params }: LoaderFunctionArgs, queryClient: QueryClient) {
  const { assignmentId } = params;

  if (!assignmentId) {
    return notFound();
  }

  queryClient.prefetchQuery(ASSIGNMENTS_QUERIES.detail(assignmentId));

  return null;
}
